import {
  SET_ADMIN_LOGIN_POPUP_VISIBLE,
  SET_ADMIN_LOGOUT_VISIBLE,
  SET_ADMIN_TOOL_SETTINGS_POPUP_VISIBLE
} from "../../../actions/actionTypes";

const initialState = {
  adminLogoutVisible: false,
  adminLoginPopupVisible: false,
  adminToolSettingsPopupVisible: false,
  adminToolSettingsPopupFeature: null,
};

export default function(state = initialState, action) {

  switch(action.type) {

    case SET_ADMIN_LOGOUT_VISIBLE:
    case SET_ADMIN_LOGIN_POPUP_VISIBLE:
    case SET_ADMIN_TOOL_SETTINGS_POPUP_VISIBLE:
      return Object.assign({}, state, {
        ...action.payload
      });
  }

  return state;

}
